import BaseService from "./support/base-service";

class StripeService extends BaseService {
	jumpToNewAccountCheckoutPageFromState() {
		return this.jumpToNewAccountCheckoutPage(
			this.store.state.newOrganizationTier,
			this.store.state.stripeDiscount,
			this.store.state.organization ? this.store.state.organization.stripeCustomerId : null
		);
	};

	jumpToNewAccountCheckoutPage(newOrganizationTier, stripeDiscount, stripeCustomerId) {
		let self = this;
		return new Promise((resolve, reject) => {

			self.mutation("createStripe", {newOrganizationTier:newOrganizationTier,stripeDiscount:stripeDiscount,stripeCustomerId:stripeCustomerId})
				.then(response =>{
					if (response) {
						window.location.href = response;
						resolve(null);
					} else {
						resolve("Unable to start checkout, please contact support for assistance.");
					}
				}).catch(error => {
					console.error("Create stripe error: " + JSON.stringify(error));
					resolve("Unable to start checkout, please contact support for assistance.");
			});
		});
	};

	jumpToEditBillingPage(stripeCustomerId) {
		let self = this;
		let planCookie = this.getCookie("plan");
		return new Promise((resolve, reject) => {
			self.query("getBillingRedirectUrl", {stripeCustomerId})
				.then(url => {
					if (url === "New Account") {
						// Customer has no subscriptions at all - Checkout is the correct destination.
						self.jumpToNewAccountCheckoutPage(planCookie ? planCookie : 'professional', false, stripeCustomerId).then(checkoutError => {
							if (checkoutError) {
								resolve(checkoutError);
							} else {
								resolve(null);
							}
						});
					} else {
						window.location.href = url;
						resolve(null);
					}
			}).catch(error => {
				// Do NOT fall back to Checkout here - for an existing subscriber that
				// creates a duplicate subscription. Surface the error instead.
				console.error("Get billing redirect error: " + JSON.stringify(error));
				resolve("Unable to open the billing page, please try again or contact support for assistance.");
			});
		});
	};

	getCookie(cname) {
		var name = cname + "=";
		var decodedCookie = decodeURIComponent(document.cookie);
		var ca = decodedCookie.split(';');
		for(var i = 0; i <ca.length; i++) {
			var c = ca[i];
			while (c.charAt(0) === ' ') {
				c = c.substring(1);
			}
			if (c.indexOf(name) === 0) {
				return c.substring(name.length, c.length);
			}
		}
		return "";
	}
}

let service = new StripeService();
export default service;
